import React from 'react';
import './index.scss';

export default ({ src, text, onClick, isActive }) => (
  <div className="vide-card" onClick={onClick}>
    <div
      className="vide-card--image"
      style={{ backgroundImage: `url(${src})`, 
        boxShadow: isActive ? '0 6px 9px 0 #ffb833' : '0 6px 9px 0 #250f8a', 
        border: isActive ? '3px solid #ffb833' : 'none' }}
    />
    <div className="vide-card--text">{text}</div>
  </div>
);




// WEBPACK FOOTER //
// /app/apps/ms/src/components/Carousel/VideoCard/index.js